import { createRouter, createWebHistory } from 'vue-router'

import { useAuthStore } from '@/Stores'
import { useNProgress } from '@vueuse/integrations/useNProgress'

import Login from '@/Pages/Auth/Login.vue'
import GiftingAndEngagement from '@/Pages/GiftingAndEngagement.vue'
import Dashboard from '@/Pages/Dashboard.vue'
import Feedback from '@/Pages/Feedback.vue'
import FeedbackSingle from '@/Pages/FeedbackSingle.vue'
import MapNearby from '@/Pages/MapNearby.vue'
import ClientContacts from '@/Pages/ClientContacts.vue'
import Client from '@/Pages/Client.vue'
import ClientNotes from '@/Pages/ClientNotes.vue'
import ProfileCaregiver from '@/Pages/CaregiverProfile.vue'
import ClientSchedule from '@/Pages/ClientSchedule.vue'
import CaregiverAvailability from '@/Pages/CaregiverAvailability.vue'
import ClientProfileEmbedded from '@/Pages/ClientProfileEmbedded.vue'
import CaregiverCapabilities from '@/Pages/CaregiverCapabilities.vue'
import CaregiverBasicInfoEmbedded from '@/Pages/CaregiverBasicInfoEmbedded.vue'
import SearchCaregiver from '@/Pages/SearchCaregiver.vue'
import QuickbooksSyncStatus from '@/Pages/QuickbooksSyncStatus.vue'
import Typography from '@/Pages/Typography.vue'


// import { useNotificationStore } from '@/Stores'

const baseTitle = ' - LifeWorx Latte'


const router = createRouter({
    scrollBehavior(to, from, savedPosition) {
        // A hash change on the same page is a section deep link that the page scrolls to itself
        if (to.hash && to.path === from.path) {
            return false;
        }
        return { top: 0 };
    },
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: "/",
            redirect: to => {
                return { path: '/dashboard' }
            },
        },
        {
            path: "/login",
            name: "login",
            component: Login,
            meta: {
                title: 'Login'
            }
        },
        {
            path: "/gifting",
            name: "gifting",
            component: GiftingAndEngagement,
            meta: {
                title: 'Gifting & Engagement'
            }
        },
        {
            path: "/dashboard",
            name: "dashboard",
            component: Dashboard,
            meta: {
                title: 'Dashboard'
            }
        },
        {
            path: "/feedback",
            name: "feedback",
            component: Feedback,
            meta: {
                title: 'Client→Caregiver Feedback'
            }
        },
        {
            path: "/feedback/caregiver/:caregiver(\\d+)",
            name: "feedback.caregiver",
            component: FeedbackSingle,
            props: true,
            meta: {
                title: 'Feedback by Caregiver'
            }
        },
        {
            path: "/feedback/client/:client(\\d+)",
            name: "feedback.client",
            redirect: to => ({ name: 'client.profile', params: { client: to.params.client }, hash: '#feedback' }),
        },
        {
            path: "/embedded/client/:coffee_client_user_profile_id(\\d+)",
            name: "client.profile.embedded",
            component: ClientProfileEmbedded,
            props: true,
            meta: {
                title: 'Client Profile (Embedded)'
            }
        },
        {
            path: "/embedded/client/nearby",
            name: "nearby.address",
            component: MapNearby,
            props: true,
            meta: {
                title: 'Who\'s Nearby'
            }
        },
        {
            path: "/embedded/client/:coffee_client_user_profile_id(\\d+)/contacts",
            name: "client.contacts",
            component: ClientContacts,
            props: true,
            meta: {
                title: 'Client Contacts'
            }
        },
        {
            path: "/embedded/client/:coffee_client_user_profile_id(\\d+)/schedule",
            name: "client.schedule",
            component: ClientSchedule,
            props: true,
            meta: {
                title: 'Client Schedule'
            }
        },
        {
            path: "/embedded/client/:coffee_client_user_profile_id(\\d+)/notes",
            name: "client.notes",
            component: ClientNotes,
            props: true,
            meta: {
                title: 'Client Notes & Activity'
            }
        },
        {
            path: "/embedded/caregiver/:coffee_caregiver_user_profile_id(\\d+)/availability",
            name: "caregiver.availability",
            component: CaregiverAvailability,
            props: true,
            meta: {
                title: 'Caregiver Availability'
            }
        },
        {
            path: "/client/create",
            name: "client.create",
            component: Client,
            props: true,
            meta: {
                title: 'Create New Client'
            }
        },
        {
            path: "/client/:client(\\d+)",
            name: "client.profile",
            component: Client,
            props: true,
            meta: {
                title: 'Client Profile'
            }
        },
        {
            path: "/caregiver/:caregiver(\\d+)",
            name: "client.caregiver",
            component: ProfileCaregiver,
            props: true,
            meta: {
                title: 'Caregiver Profile'
            }
        },
        {
            path: "/embedded/caregiver/:coffee_caregiver_user_profile_id(\\d+)/capabilities",
            name: "caregiver.capabilities",
            component: CaregiverCapabilities,
            props: true,
            meta: {
                title: 'Caregiver Care Need'
            }
        },
        {
            path: "/embedded/caregiver/:coffee_caregiver_user_profile_id(\\d+)/basic-info",
            name: "caregiver.basic-info",
            component: CaregiverBasicInfoEmbedded,
            props: true,
            meta: {
                title: 'Caregiver Basic Info'
            }
        },
        {
            path: "/search/caregivers",
            name: "search.caregivers",
            component: SearchCaregiver,
            props: true,
            meta: {
                title: 'Search Caregivers'
            }
        },
        {
            path: "/search/caregivers/for/:client_id(\\d+)",
            name: "search.caregivers.client",
            component: SearchCaregiver,
            props: true,
            meta: {
                title: 'Search Caregivers'
            }
        },
        {
            path: "/search/caregivers/mine",
            name: "search.caregivers.mine",
            component: SearchCaregiver,
            props: true,
            meta: {
                title: 'Search Caregivers'
            }
        },
        {
            path: "/status/quickbooks",
            name: "status.quickbooks",
            component: QuickbooksSyncStatus,
            meta: {
                title: 'QuickBooks Sync Status'
            }
        },
    ].concat(import.meta.env.VITE_APP_ENVIRONMENT == 'local' ? [
        {
            path: "/typography",
            name: "typography",
            component: Typography,
            props: true,
            meta: {
                title: 'Typography'
            }
        },
    ] : []),
})

router.beforeEach((to, from, next) => {
    const { isLoading } = useNProgress()
    const { auth } = useAuthStore()
    isLoading.value = true
    auth.loading = true

    next()
})

router.beforeEach((to, from, next) => {
    if (to && to.name && next) {
        // document.title = util.titleCase(to.name.replace('-', ' ')) + baseTitle
        document.title = to.meta.title + baseTitle
        // TODO handle subroute naming here and figure out how to prepend subpage titles from component data or props
        next()
    }
})

router.beforeEach(async (to) => {
    const publicPages = ['/login'];
    const authRequired = !publicPages.includes(to.path);
    const { auth } = useAuthStore();
    if (auth.authenticated && to.path == '/login') {
        return {
            path: '/'
        }
    }
    if (authRequired && (!auth.authenticated)) {
        return {
            path: '/login',
            query: { returnUrl: to.href }
        }
    }

    // if (to.params.period && isNaN(to.params.period)) {
    //     const notificationStore = useNotificationStore()
    //     notificationStore.add('Error 404', 'error', 'Invoice not found')
    //     return {
    //         path: '/'
    //     }
    // }
})

router.afterEach(() => {
    useNProgress(1.0)
    const { auth } = useAuthStore()
    auth.loading = false
})

export default router;
